import React from "react";

export default function Signal3({
  fill = "black",
  width = "40px",
  height = "40px",
  ...others
}) {
  return (
    <svg 
    width={width}
    height={height}
    viewBox="0 0 700 500" 
    xmlns="http://www.w3.org/2000/svg"
    {...others}>
   <g>
  <path d="m198.05 340.09c-4.9531 0.003906-8.9688 4.0195-8.9727 8.9727v69.07c0.003907 4.9531 4.0195 8.9688 8.9727 8.9727h55.262c4.9531-0.003906 8.9688-4.0195 8.9727-8.9727v-69.07c-0.003906-4.9531-4.0195-8.9688-8.9727-8.9727z" fill={fill}/>
  <path d="m280.93 271.02c-2.3828 0-4.668 0.94922-6.3516 2.6367-1.6797 1.6875-2.625 3.9727-2.6211 6.3555v138.12c0.003907 4.9531 4.0195 8.9688 8.9727 8.9727h55.262c4.9531-0.003906 8.9688-4.0195 8.9727-8.9727v-138.12c0.003907-2.3828-0.9375-4.668-2.6211-6.3555-1.6836-1.6875-3.9688-2.6367-6.3516-2.6367z" fill={fill}/>
  <path d="m363.8 201.96c-4.9531 0.003906-8.9688 4.0195-8.9727 8.9727v207.19c0.003907 4.9531 4.0195 8.9688 8.9727 8.9727h55.262c4.957-0.003906 8.9688-4.0195 8.9727-8.9727v-207.19c-0.003906-4.9531-4.0156-8.9688-8.9727-8.9727z" fill={fill}/>
  <path d="m446.68 132.9c-4.9531 0-8.9688 4.0156-8.9727 8.9727v276.26c0.003907 4.9531 4.0195 8.9688 8.9727 8.9727h55.266c4.9531-0.003906 8.9688-4.0195 8.9727-8.9727v-276.26c-0.003907-4.957-4.0195-8.9727-8.9727-8.9727zm8.9922 17.965h37.297v258.29h-37.297z" fill={"#e0e0e0"}/>
 </g>
    </svg>
  );
}
